export const adapterContactSimple = contact => {
  return {
    id: contact?.id,
    alias: contact?.alias,
    email: contact?.email,
    name: `${contact?.first_name} ${contact?.last_name}`,
    isFavorite: contact?.is_favorite,
    contact_id: contact?.contact_id,
  };
};
